<template>
    <div class="container">
        <div class="content" v-show="showContent">
            <div class="info">
                <div class="test-name">{{testName}}</div>
                <div class="info-title">测评说明</div>
                <div class="info-content">{{des}}</div>
                <div class="info-title">注意事项</div>
                <div class="info-item">· 题目共{{testLn}}道，请在30分钟内完成作答。</div>
                <div class="info-item">· 答案无对错之分，不用过度思考，根据第一反应. 选择即可。</div>
                <div class="info-item">· 答题完成后，将可获得评估报告及相应建议，您也可以前往【我的】-【服务记录】中找到历史测评结果。</div>
                <div class="info-item">· 该测评结果仅供参考，不能以此作相关诊断。如有疑问，请咨询专业人员。</div>
            </div>
            <div class="go">
                <div class="go-box">
                    <div class="go-btn" @click="go">开始测评</div>
                </div>            
            </div>
        </div>
        <div class="main" v-show="!showContent">
            <div class="test-step">
                <div class="step-box">
                    <div class="step-num"><span class="now-step">{{testNum+1}}</span><span class="all-step">/{{testLn}}</span></div>
                    <div class="progress-box">
                        <div class="progress" :style="{width:progress+'px'}"></div>
                    </div>
                    <div class="test-time">{{testTime}}</div>
                    <img src="../assets/images/emotion_qa.png" alt="" class="test-qa" @click="pointTest">
                </div>                
            </div>
            <div class="test-list">
                <div class="test-classify" v-for="(item,index) in test_list" :key="item.id">
                    <radioTest v-show="item.question_type=='单选'&&testNum==index" :test="test_list[index]" :index="index"  :id="item.id" @choice-radio="choiceRadio"></radioTest>
                </div>
            </div>            
            <div class="pre-next">
                <div class="next-box">
                    <div class="pre-btn" @click="pre" v-show="testNum!=0">上一题</div>
                    <div class="next-btn" @click="next" v-show="testNum+1!=testLn">下一题</div>
                    <div class="next-btn" @click="sub" v-show="testNum+1==testLn">提交</div>
                </div>            
            </div>
        </div>
        <div class="point-modal" v-show="showPoint">
            <div class="point">
                <div class="point-title">注意事项</div>
                <div class="point-item">· 题目共{{testLn}}道，请在30分钟内完成作答。</div>
                <div class="point-item">· 答案无对错之分，不用过度思考，根据第一反应. 选择即可。</div>
                <div class="point-item">· 答题完成后，将可获得评估报告及相应建议，您也可以前往【我的】-【服务记录】中找到历史测评结果。</div>
                <div class="point-item">· 该测评结果仅供参考，不能以此作相关诊断。如有疑问，请咨询专业人员。</div>
                <div class="i-know" @click="closePoint">我知道了</div>
            </div>
        </div>
        <div class="over-modal" v-show="showOver">
            <div class="over">
                <img src="../assets/images/over-time.png" alt="" class="over-time">
                <div class="over-title">时间到了</div>
                <div class="over-content">您未在规定时间内完成作答，为保证作答质量，请点击【重新作答】从第一题开始答题。</div>
                <div class="over-con">
                    <div class="keep" @click="keep">继续答题</div>
                    <div class="restart" @click="restart">重新作答</div>
                </div>
            </div>
        </div>
        <div class="out-modal" v-show="showOut">
            <div class="out">
                <div class="out-title">退出将无法保存</div>
                <div class="out-content">中途退出后，测评记录无法保存，建议您完成测评</div>
                <div class="btns">
                    <div class="cancel" @click="out">退出</div>
                    <div class="sure" @click="showOut=false">继续测评</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {test_item,add_test} from '../api/server'
import radioTest from './test/radio-test.vue'
export default {
    components: {
        radioTest
    },
    data() {
        return {
            imei:'',
            loginPhone:'',
            showContent:true,
            testNum:0,
            testTime:'30:00',
            testName:'',
            des:'',
            testLn:'',
            progress:'',
            test_list:[],
            evaluate:[],
            answerData:[],
            showPoint:false,
            showOver:false,
            showOut:false,
            goOut:null
        };
    },
    computed: {},
    methods: {
        go(){
            this.showContent=false;
            let allTime=1800;
            let timer=setInterval(()=>{
                allTime=allTime-1;
                let min=parseInt(allTime/60)
                let sec=allTime%60
                this.testTime=min+':'+sec
                if(allTime==0){
                    this.testTime='00:00'
                    this.showOver=true
                    clearInterval(timer)
                }
            },1000)
        },
        pre(){
            this.testNum=this.testNum-1;
            this.progress=(this.testNum+1)/this.testLn*220;
        },
        next(){
            if(this.answerData[this.testNum].option.length==0){
                return this.$toast('请完成本题')
            }
            this.testNum=this.testNum+1;
            this.progress=(this.testNum+1)/this.testLn*220;
        },
        pointTest(){
            this.showPoint=true;
        },
        closePoint(){
            this.showPoint=false;
        },
        keep(){
            this.showOver=false;
        },
        restart(){
            location.reload()
        },
        sub(){
            if(this.answerData[this.testNum].option.length==0){
                return this.$toast('请完成本题')
            }
            //算维度
            let dimensionAll=this.evaluate;
            let dimensionTag=[];
            let dimensionData=[];
            this.answerData.forEach(item=>{
                item.options_dimension.forEach(t=>{
                    if(dimensionTag.indexOf(t)==-1){
                        dimensionTag.push(t)
                    }
                })
            })
            dimensionTag.forEach(item=>{
                dimensionData.push({dem:item,src:0,score:'',tag:'',describe:'',evaluate:'',explain:'',suggest:''})
            })
            this.answerData.forEach(item=>{
                item.option_score.forEach(t=>{
                    if(t!=-1){
                        item.options_dimension.forEach(q=>{
                            if(dimensionTag.indexOf(q)!=-1){
                                dimensionData.forEach(a=>{
                                    if(a.dem==q){
                                        a.src+=Number(t);
                                    }
                                })
                            }
                        })
                    }
                })
            })
            dimensionData.forEach(item=>{
                dimensionAll.forEach(t=>{
                    let start=t.score[0];
                    let end=t.score[1];
                    if(item.dem==t.dimension){
                        if(item.src>=start&&item.src<=end){
                            item.score=t.score;
                            item.tag=t.tag;
                            item.describe=t.describe;
                            item.evaluate=t.evaluate;
                            item.explain=t.explain;
                            item.suggest=t.suggest;
                        }
                    }
                })
            })
            let date=new Date();
            let time=parseInt(date.getTime()/1000)
            let ansStr=JSON.stringify(this.answerData)
            let dimensionStr=JSON.stringify(dimensionData)
            let evaluate=JSON.stringify(this.evaluate)
            add_test(this.loginPhone,this.imei,time,'test',this.testName,ansStr,dimensionStr,evaluate).then(res=>{
                if(res.status==200){
                    if(this.testName=='大五人格'){
                        this.$router.push({ path: '/test-report-a-copy', query: { id: res.data.testData[0].id,phone:this.loginPhone}})
                    }else{
                        this.$router.push({ path: '/test-report-b-copy', query: { id: res.data.testData[0].id,phone:this.loginPhone}})
                    }
                }
            })
        },
        testItem(){
            test_item(this.$route.query.id).then(res=>{             
                if(res.status==200){                  
                    let test=JSON.parse(res.data.test[0].test_content)
                    let evaluate=JSON.parse(res.data.test[0].evaluate)
                    let testName=test.title
                    let des=test.des
                    this.testName=testName
                    this.des=des
                    this.evaluate=evaluate
                    this.test_list=test.item
                    this.testLn=test.item.length
                    this.progress=(this.testNum+1)/this.testLn*220;
                    let answerData=[]
                    this.test_list.forEach((item)=>{
                        if(item.question_type != "部分说明"){
                            if (item.question_type == "单选矩阵") {
                                item.options.forEach(function (t, i) {
                                    let questionItem = {
                                        question_id: item.id,
                                        hide: 0,
                                        question: item.question,
                                        sub_question: t,
                                        question_type: item.question_type,
                                        option: [],
                                        options_dimension: item.options_dimension[i],
                                        option_score: [],
                                        replenish: [],
                                        end_time: [],
                                        upload_time: ''
                                    }
                                    answerData.push(questionItem)
                                })
                            } else {
                                let questionItem = {
                                    question_id: item.id,
                                    hide: 0,
                                    question: item.question,
                                    sub_question: '-1',
                                    question_type: item.question_type,
                                    option: [],
                                    options_dimension: item.options_dimension,
                                    option_score: [],
                                    replenish: [],
                                    end_time: [],
                                    upload_time: ''
                                }
                                answerData.push(questionItem)
                            }
                        }
                    })
                    this.answerData=answerData
                }
            })
        },
        //单选答案
        choiceRadio(choice){           
            let {id,ans,score}=choice            
            this.answerData.forEach(item=>{
                if(item.question_id==id){
                    if (item.option.length == 0) {
                        item.option.push(ans);
                    } else {
                        item.option = [];
                        item.option.push(ans)
                    }    
                    if (item.option_score.length == 0) {
                        item.option_score.push(score);
                    } else {
                        item.option_score = [];
                        item.option_score.push(score)
                    }                 
                }
            })
        },
        out(){
            this.goOut()
            this.$router.push('/service')
        },
    },
    created() {
        this.testItem()  
        let imei=localStorage.getItem('imei');
        this.imei=imei;
        let phone=Math.round(Math.random() * 100000000);
        this.loginPhone=phone;      
    },
};
</script>
<style lang='less' scoped>
.container{
    padding: 16px;
}
.content{
    padding:12px;
    border-radius: 10px;
    background-color: #fff;
}
.test-name{
    line-height: 34px;
    font-size: 18px;
    font-weight: 900;
    color: #333;
    text-align: center;
}
.info-title{
    height: 34px;
    line-height: 34px;
    font-size: 18px;
    font-weight: 500;
    color: #333;
}
.info-content{
    line-height: 24px;
    text-indent: 2em;
    font-size: 14px;
    color: #666;
    margin-bottom: 30px;
}
.info-item{
    text-indent: 2em;
    line-height: 24px;
    font-size: 14px;
    color: #666;
}
.go{
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    z-index: 10;
}
.go-box{
    background-color: #fff;
    padding: 10px 16px;
}
.go-btn{
    height: 50px;
    line-height: 50px;
    border-radius: 25px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: #01D6D6;
}
@media (min-width: 768px){ /*0~768*/
    .go-box{
        width: 400px;
        margin: 0 auto;
    }
}
.pre-next{
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    z-index: 10;
}
.next-box{
    background-color: #fff;
    padding: 10px 16px;
    display: flex;
    justify-content: space-around;
}
.pre-btn{
    width: 48%;
    height: 50px;
    line-height: 50px;
    border-radius: 25px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #01D6D6;
    background-color: #fff;
    border: 1px solid #01D6D6;
}
.next-btn{
    width: 48%;
    height: 50px;
    line-height: 50px;
    border-radius: 25px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: #01D6D6;
}
@media (min-width: 768px){ /*0~768*/
    .next-box{
        width: 400px;
        margin: 0 auto;
    }
}
.test-step{
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    z-index: 10;
}
.step-box{
    background-color: #fff;
    padding: 0px 16px;
    height: 50px;
    display: flex;
    justify-content: space-between;
}
.step-num{
    height: 24px;
    margin-top: 13px;    
}
.now-step{
    line-height: 24px;
    font-size: 24px;
    font-weight: 500;
    font-family: 'avenir';
}
.all-step{
    line-height: 14px;
    margin-top: 10px;
    font-size: 12px;
    color:#999999 ;
}
.progress-box{
    margin-top: 17px;
    width: 220px;
    height: 16px;
    border-radius: 8px;
    background-color: #EDF1F1;
    position: relative;
}
.progress{
    width: 20px;
    height: 16px;
    border-radius: 8px;
    background-color: #01D6D6;
    position: absolute;
    left: 0px;
    top: 0px;
}
.test-time{
    height: 14px;
    line-height: 14px;
    margin-top: 18px;
    font-size: 12px;
    color: #999999;
    font-weight: 500;
}
.test-qa{
    height: 16px;
    margin-top: 17px;
}
.test-list{
    margin-top: 50px;
    padding-bottom: 80px;
}
.point-modal{
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 99;
}
.point{
    padding: 30px;
    border-radius: 10px;
    background-color: #fff;
    width: 190px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
}
.point-title{
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    text-align: center;
    padding-bottom: 30px;
}
.point-item{
    line-height: 24px;
    font-size: 14px;
    color: #666666;
}
.i-know{
    margin-top: 30px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 24px;
    background-color: #01D6D6;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
}
.over-modal{
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 100;
}
.over{
    padding: 30px;
    border-radius: 10px;
    background-color: #fff;
    width: 190px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
}
.over-time{
    display: block;
    height: 80px;
    width: 80px;
    margin: 0 auto;
}
.over-title{
    margin-top: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    text-align: center;
}
.over-content{
    padding-top: 30px;
    line-height: 24px;
    color: #666;
    font-size: 14px;
}
.over-con{
    margin-top: 30px;
    height: 48px;
    display: flex;
    justify-content: space-between;
}
.keep{
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    background-color: #F2F6F6;
    border-radius: 24px;
    width: 48%;
}
.restart{
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: #01D6D6;
    border-radius: 24px;
    width: 48%;
}
.out-modal{
    position: fixed;
    left: 0px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 10;
    width: 100%;
    height: 100%;
}
.out{
    width: 210px;
    padding: 30px;
    background-color: #fff;
    border-radius: 10px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}
.out-title{
    height: 20px;
    line-height: 20px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
    margin-bottom: 30px;
    text-align: center;
}
.out-content{
    line-height: 20px;
    font-size: 14px;
    color: #333;
    margin-bottom: 30px;
    text-align: center;
}
.btns{
    height: 48px;
    display: flex;
    justify-content: space-between;
}
.cancel{
    height: 48px;
    width: 48%;
    border-radius: 24px;
    line-height: 48px;
    text-align: center;
    background-color: #F2F6F6;
    font-size: 16px;
    font-weight: 500;
    color: #333;
}
.sure{
    height: 48px;
    width: 48%;
    border-radius: 24px;
    line-height: 48px;
    text-align: center;
    background-color: #01D6D6;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
}
</style>